import React, { useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import EditableField from '../EditableField';
import ConfirmationDialog from '../ConfirmationDialog';
import styles from '../../DataExtractionTemplate.module.scss';
import { DataExtractionTemplateState } from '../../DataExtractionTemplate';
import {
  NO_EQUIVALENT_VALUE,
  validate,
} from 'pages/DataExtraction/components/editableFieldValidation';
import { Icon, IconList, Link } from 'components/core';

type Props = {
  hasExtractedData: boolean;
  fullWidth?: boolean;
};

const CharacteristicsFields = ({ hasExtractedData, fullWidth }: Props) => {
  const [modal, setModal] = useState<React.ReactElement | null>();
  const { getValues } = useFormContext();
  const MAX_LENGTH = 255;

  const characteristics = useFieldArray<DataExtractionTemplateState>({
    name: 'interventions.characteristics',
  });
  const handleAppend = async () => {
    characteristics.append({
      name: '',
    });
  };

  const handleRemove = (index: number) => {
    characteristics.remove(index);
  };

  return (
    <div>
      {modal}
      {characteristics.fields?.map((field, index) => {
        return (
          <EditableField
            key={field.id}
            index={index}
            name="interventions.characteristics"
            label="Intervention characteristic"
            fullWidth={fullWidth}
            onDelete={() => {
              const { id } = getValues(
                `interventions.characteristics.${index}`
              );

              if (id && hasExtractedData) {
                setModal(
                  <ConfirmationDialog
                    onConfirm={() => handleRemove(index)}
                    onClose={() => setModal(null)}
                  />
                );
              } else {
                handleRemove(index);
              }
            }}
            validate={(value, existingFields) => {
              return validate(
                value,
                existingFields,
                [],
                NO_EQUIVALENT_VALUE,
                MAX_LENGTH
              );
            }}
          />
        );
      })}
      <Link
        onClick={handleAppend}
        variant="primary"
        className={styles.AddButton}
      >
        <Icon icon={IconList.light.faPlus} /> Add detail
      </Link>
    </div>
  );
};

export default CharacteristicsFields;
